import { createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../apiConfig';
import {
  IOrchestrationsByModuleServer,
  IOrchestrationsByModuleServerRequest,
} from 'interfaces/modules/module.interface';
import { IServerWorkflow } from 'interfaces/workflow.interface';
import { handleThunkError } from 'utils/thunkErrorHandler/thunkErrorHandler';
import { IDropZoneWorkflowState } from 'interfaces/designOrchestration/designOrchestrationState.interface';

const BASE_URL = '/csb/workflows';

export const fetchWorkflows = createAsyncThunk(
  'runOrchestrations/fetchWorkflows',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClient.get<IServerWorkflow[]>(`${BASE_URL}`);
      return response.data;
    } catch (error) {
      return handleThunkError(error, rejectWithValue);
    }
  }
);

export const fetchWorkflowsNoLoading = createAsyncThunk(
  'runOrchestrations/fetchWorkflowsNoLoading',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClient.get<IServerWorkflow[]>(`${BASE_URL}`);
      return response.data;
    } catch (error) {
      return handleThunkError(error, rejectWithValue);
    }
  }
);

export const fetchWorkflowsNames = createAsyncThunk(
  'runOrchestrations/fetchWorkflowsNames',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClient.get<string[]>(`${BASE_URL}/names/all`);
      return response.data ?? [];
    } catch (error) {
      return handleThunkError(error, rejectWithValue);
    }
  }
);

export const getWorkflowsByModule = createAsyncThunk<
  IOrchestrationsByModuleServer,
  IOrchestrationsByModuleServerRequest
>(
  'runOrchestrations/getWorkflowsByModule',
  async ({ slave, moduleTextId, moduleVersion }, { rejectWithValue }) => {
    try {
      const response = await apiClient.get<IOrchestrationsByModuleServer>(
        `${BASE_URL}/${slave}/${moduleTextId}/${moduleVersion}`
      );
      return response.data;
    } catch (error) {
      return handleThunkError(error, rejectWithValue);
    }
  }
);

export const createXMLOrchestration = createAsyncThunk<
  any,
  IDropZoneWorkflowState['workflow']
>(
  'designOrchestration/createXMLOrchestration',
  async (workflow, { rejectWithValue }) => {
    try {
      const response = await apiClient.post<any>(
        `${BASE_URL}/export`,
        workflow
      );
      return response.data;
    } catch (error) {
      return handleThunkError(error, rejectWithValue);
    }
  }
);
